import { render, staticRenderFns } from "./GuideStatusBadge.vue?vue&type=template&id=4b0e5059"
import script from "./GuideStatusBadge.vue?vue&type=script&lang=js"
export * from "./GuideStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports